"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Skills;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _MainMenuModule = _interopRequireDefault(require("../../MainMenu.module.scss"));

var _Button = _interopRequireDefault(require("../../../../../../inputElements/Button/Button"));

var _EButtonType = _interopRequireDefault(require("../../../../../../inputElements/Button/EButtonType"));

var _entities = require("../../../../../../entities");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var SKILLBAR_MAX_PAGE = 8;
var SKILLBAR_MAX_ENTRY = 8;

function Skills(_ref) {
  var skillBars = _ref.skillBars,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  if (skillBars && skillBars.length > SKILLBAR_MAX_PAGE) {
    throw new Error("skillBars array with invalid size '".concat(skillBars.length, "' was passed to MainMenu > Skills."));
  }

  if (skillBars) {
    skillBars.forEach(function (skillBar) {
      if (skillBar && skillBar.length > SKILLBAR_MAX_ENTRY) {
        throw new Error("skillBar with invalid size '".concat(skillBar.length, "' was passed to MainMenu > Skills."));
      }
    });
  }

  var _useState = (0, _react.useState)(1),
      _useState2 = _slicedToArray(_useState, 2),
      currentPage = _useState2[0],
      setCurrentPage = _useState2[1];

  var renderCurrentSkillBar = (0, _react.useCallback)(function () {
    var currentBar = (skillBars === null || skillBars === void 0 ? void 0 : skillBars[currentPage - 1]) || [];
    return currentBar.map(function (skill, index) {
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/no-array-index-key
        _react.default.createElement("div", {
          key: "".concat(currentPage, "_").concat(index),
          className: (0, _classnames.default)(_MainMenuModule.default.skill, _MainMenuModule.default["skill".concat(index + 1)])
        }, skill && /*#__PURE__*/_react.default.createElement(_entities.ClassSkill, {
          skill: skill
        }))
      );
    });
  }, [skillBars, currentPage]);
  var handleChangeSkillBar = (0, _react.useCallback)(function (direction) {
    var newPage = currentPage;

    if (direction === "up") {
      newPage += 1;
      if (newPage > SKILLBAR_MAX_PAGE) newPage = 1;
    } else if (direction === "down") {
      newPage -= 1;
      if (newPage < 1) newPage = SKILLBAR_MAX_PAGE;
    }

    setCurrentPage(newPage);
  }, [currentPage]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_MainMenuModule.default.skills, className),
    style: style
  }, renderCurrentSkillBar(), /*#__PURE__*/_react.default.createElement("div", {
    className: _MainMenuModule.default.pageValue
  }, currentPage), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_MainMenuModule.default.btn, _MainMenuModule.default.up)
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.COMBO_UP_15X15,
    onClick: function onClick() {
      handleChangeSkillBar("up");
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_MainMenuModule.default.btn, _MainMenuModule.default.down)
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.COMBO_DOWN_15X15,
    onClick: function onClick() {
      handleChangeSkillBar("down");
    }
  })));
}